import { useEffect, useRef } from 'react';
import { useFormActions, useFormField } from '../core';
import { config } from '../config';

export const useShouldValidateField = (
  fieldId: string,
  shouldValidate: boolean,
  suffix: string = config.shouldValidateFieldSuffix,
) => {
  const { setFieldValue } = useFormActions();
  const writtenRef = useRef<boolean | undefined>(undefined);

  const shouldValidateFieldId = `${fieldId}${suffix}`;

  const [{ value }] = useFormField<boolean | undefined>(shouldValidateFieldId);

  // Writes on the first run even over a matching seed (its validation pass fills errors
  // before any submit), and again whenever a reinitialize puts back a seed that disagrees.
  useEffect(() => {
    if (writtenRef.current !== shouldValidate || value !== shouldValidate) {
      writtenRef.current = shouldValidate;

      setFieldValue(shouldValidateFieldId, shouldValidate, true);
    }
  }, [setFieldValue, shouldValidateFieldId, shouldValidate, value]);

  // Unmount only: as the effect above's cleanup, this write would change value and loop.
  useEffect(
    () => () => {
      setFieldValue(shouldValidateFieldId, false, true);
    },
    [setFieldValue, shouldValidateFieldId],
  );
};
